var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tag mr-1 is-dark is-rounded is-font-small",staticStyle:{"float":"right","width":"fit-content","background-color":"black","color":"white"}},[_vm._v("Bewertung: "+_vm._s(_vm.rating)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }